import machineDefaultImage from '../../../../images/machineImageEmpty.svg';
import { typedDocumentsImageUrl } from '../../../../utils/imageProxy';
import { ModifierEquipment } from '../../editMachine/modifierEquipment';
import { useHasPermission } from '../../../../hooks/useHasPermission';
import { Box, Typography, Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import Iconify from '../../../Iconify';
import { useState } from 'react';
import '../../../../css/machines/localisationEtStatut.css';

const EquipmentBox = ({ image, title }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: "column", gap: "3px", mb: 2 }}>
            <img src={image} alt="icon" style={{ width: '45px', height: '45px', borderRadius: '2px', objectFit: "cover" }} loading='lazy' decoding='async' />
            <Typography className='modeEtConseigne_text_response'>{title}</Typography>
        </Box>
    );
};

const Equipment = () => {

    const machineDetailsData = useSelector((state) => state.MachineDetailsData);
    const hasMachineUpdatePermission = useHasPermission('machine_update');

    const [modifyEquipment, setModifyEquipment] = useState(false);

    return (
        <Box className='localisationEtStatut_box'>
            <Box className='localisation_edit_box'>
                <Typography className='localisationEtStatut_title'>Équipements</Typography>
                {hasMachineUpdatePermission && !machineDetailsData?.is_archived && <Iconify className='localisationEtStatut_edit_icon' icon={"ic:outline-edit"} onClick={() => setModifyEquipment(true)} />}
            </Box>
            <Box className='localisationEtStatut_icon_title_response_box'>
                {machineDetailsData?.equipment_machine?.length > 0 ? (
                    <Grid container spacing={4}>
                        {machineDetailsData?.equipment_machine?.map((e) => {
                            const img = typedDocumentsImageUrl(e?.equipment?.equipment_document, { size: 'picto', fallback: machineDefaultImage });
                            return (
                                <Grid key={e?.id} item xs={12} sm={12} md={12} lg={6} xl={6}>
                                    <EquipmentBox
                                        image={img}
                                        title={e?.equipment?.name}
                                    />
                                </Grid>
                            );
                        })}
                    </Grid>)
                    :
                    <Typography className='modeEtConsigne_dashed_typography' sx={{ width: '100%' }}>Il n’existe aucun contenu dans cette section</Typography>
                }
            </Box>

            {modifyEquipment &&
                <ModifierEquipment
                    modifyEquipment={modifyEquipment}
                    setModifyEquipment={setModifyEquipment}
                />
            }
        </Box>
    )
}

export default Equipment
